import { render, staticRenderFns } from "./Display.vue?vue&type=template&id=4ad8c80a&scoped=true"
import script from "./Display.vue?vue&type=script&lang=js"
export * from "./Display.vue?vue&type=script&lang=js"
import style0 from "./Display.vue?vue&type=style&index=0&id=4ad8c80a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ad8c80a",
  null
  
)

export default component.exports